<template>
  <v-dialog
    v-model="show"
    max-width="440px"
  >
    <v-card>
      <div
        class="d-flex justify-space-between"
      >
        <v-card-title>Are you sure you want to delete reports?</v-card-title>
        <v-btn
          class="mr-1 mt-1"
          icon
          small
          @click="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          small
          color="primary"
          outlined
          @click="show = false"
        >
          cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          small
          color="red darken-2 white--text"
          @click="deleteReport"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DeleteReportDialog',
  props: {
    value: {
      required: true,
      default: () => {
        return {
          show: Boolean,
          reportID: Array
        }
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value.show
      },
      set (val) {
        this.$emit('input', {
          show: val,
          reportID: val ? this.value.reportID : null
        })
      }
    },
    reportingIDs () {
      return this.value.reportID.join(',')
    }
  },
  methods: {
    deleteReport () {
      this.axios.post('/api/delete-reports', {
        Reporting_IDs: this.reportingIDs
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Reports successfuly deleted' })
        this.$emit('reportDeleted', { deletedReports: this.value.reportID })
        this.show = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
